import type { Category } from '../types';

export const CATEGORIES: Category[] = [
  {
    id: 'personal-safety',
    name: 'Personal Safety',
    description: 'Keep yourself safe from strangers and unsafe situations',
    icon: '🛡️',
    color: 'from-violet-500 to-purple-600',
    bgColor: 'bg-violet-50',
    textColor: 'text-violet-700',
  },
  {
    id: 'emergency-skills',
    name: 'Emergency Skills',
    description: 'What to do when something goes wrong',
    icon: '🚨',
    color: 'from-red-400 to-rose-600',
    bgColor: 'bg-red-50',
    textColor: 'text-red-700',
  },
  {
    id: 'travel-public',
    name: 'Travel & Public Places',
    description: 'Stay safe when you\'re out and about',
    icon: '🗺️',
    color: 'from-blue-400 to-sky-600',
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-700',
  },
  // ── 12 new categories (Task 4) ──────────────────────────────────────────────
  {
    id: 'navigating-emotions',
    name: 'Navigating Emotions',
    description: 'Understand and manage feelings in healthy ways',
    icon: '💛',
    color: 'from-yellow-400 to-orange-400',
    bgColor: 'bg-yellow-50',
    textColor: 'text-yellow-700',
  },
  {
    id: 'body-safety-boundaries',
    name: 'Body Safety & Personal Boundaries',
    description: 'Know your body rights and personal boundaries',
    icon: '🛡️',
    color: 'from-rose-400 to-pink-600',
    bgColor: 'bg-rose-50',
    textColor: 'text-rose-700',
  },
  {
    id: 'online-safety-digital',
    name: 'Online Safety & Digital Life',
    description: 'Stay safe and smart in the digital world',
    icon: '🌐',
    color: 'from-cyan-500 to-blue-600',
    bgColor: 'bg-cyan-50',
    textColor: 'text-cyan-700',
  },
  {
    id: 'friendships-social-skills',
    name: 'Friendships & Social Skills',
    description: 'Build great friendships and strong social skills',
    icon: '🤝',
    color: 'from-pink-400 to-rose-500',
    bgColor: 'bg-pink-50',
    textColor: 'text-pink-700',
  },
  {
    id: 'dealing-with-conflict',
    name: 'Dealing with Conflict',
    description: 'Handle disagreements calmly and fairly',
    icon: '⚖️',
    color: 'from-amber-400 to-orange-500',
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-700',
  },
  {
    id: 'resilience-growth',
    name: 'Resilience & Growth Mindset',
    description: 'Bounce back from setbacks and keep growing',
    icon: '🌱',
    color: 'from-green-500 to-teal-600',
    bgColor: 'bg-green-50',
    textColor: 'text-green-700',
  },
  {
    id: 'healthy-habits',
    name: 'Healthy Habits',
    description: 'Sleep, food, movement and daily routines',
    icon: '🥗',
    color: 'from-lime-400 to-green-500',
    bgColor: 'bg-lime-50',
    textColor: 'text-lime-700',
  },
  {
    id: 'gratitude-mindfulness',
    name: 'Gratitude & Mindfulness',
    description: 'Appreciate life and be present in each moment',
    icon: '🧘',
    color: 'from-violet-400 to-purple-500',
    bgColor: 'bg-violet-50',
    textColor: 'text-violet-700',
  },
  {
    id: 'money-responsibility',
    name: 'Money & Responsibility',
    description: 'Learn how money works and how to manage it',
    icon: '💰',
    color: 'from-emerald-400 to-green-600',
    bgColor: 'bg-emerald-50',
    textColor: 'text-emerald-700',
  },
  {
    id: 'community-kindness',
    name: 'Community & Kindness',
    description: 'Care for others and contribute to your community',
    icon: '🌍',
    color: 'from-sky-400 to-blue-500',
    bgColor: 'bg-sky-50',
    textColor: 'text-sky-700',
  },
  {
    id: 'family-relationships',
    name: 'Family & Relationships',
    description: 'Build strong bonds with the people you love',
    icon: '👨‍👩‍👧',
    color: 'from-warm-400 to-amber-500',
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-700',
  },
  {
    id: 'identity-self-expression',
    name: 'Identity & Self-Expression',
    description: 'Know who you are and express yourself confidently',
    icon: '🌈',
    color: 'from-fuchsia-400 to-pink-500',
    bgColor: 'bg-fuchsia-50',
    textColor: 'text-fuchsia-700',
  },
  // ── Original remaining categories ────────────────────────────────────────────
  {
    id: 'outdoor-safety',
    name: 'Outdoor Safety',
    description: 'Enjoy the outdoors safely',
    icon: '🌿',
    color: 'from-green-400 to-emerald-600',
    bgColor: 'bg-green-50',
    textColor: 'text-green-700',
  },
  {
    id: 'online-safety',
    name: 'Online Safety',
    description: 'Stay safe on the internet and devices',
    icon: '💻',
    color: 'from-cyan-400 to-teal-600',
    bgColor: 'bg-cyan-50',
    textColor: 'text-cyan-700',
  },
  {
    id: 'bullying-social',
    name: 'Bullying & Social Safety',
    description: 'Handle bullying and unkind behaviour',
    icon: '🤝',
    color: 'from-orange-400 to-amber-600',
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-700',
  },
  {
    id: 'friendships-social',
    name: 'Friendships & Social Skills',
    description: 'Build great friendships and social skills',
    icon: '👫',
    color: 'from-pink-400 to-rose-500',
    bgColor: 'bg-pink-50',
    textColor: 'text-pink-700',
  },
  {
    id: 'confidence-boundaries',
    name: 'Confidence & Boundaries',
    description: 'Know your limits and speak up for yourself',
    icon: '⭐',
    color: 'from-yellow-400 to-amber-500',
    bgColor: 'bg-yellow-50',
    textColor: 'text-yellow-700',
  },
  {
    id: 'growing-up',
    name: 'Growing Up & Body Awareness',
    description: 'Understand your body and growing up',
    icon: '🌱',
    color: 'from-lime-400 to-green-500',
    bgColor: 'bg-lime-50',
    textColor: 'text-lime-700',
  },
  {
    id: 'money-skills',
    name: 'Money Skills',
    description: 'Learn how money works and how to use it wisely',
    icon: '💰',
    color: 'from-indigo-400 to-violet-500',
    bgColor: 'bg-indigo-50',
    textColor: 'text-indigo-700',
  },
];

export const getCategoryById = (id: string): Category | undefined =>
  CATEGORIES.find((c) => c.id === id);
